<template>
    <div>
        <div class="text-content">
            <EmptySpace :options="{ size: 'lg' }" />
            <p :class="small ? 'text-title-large text-center' : 'text-headline'">
                {{ title }}
            </p>
            <p
                v-if="description"
                class="text-paragraph text-center"
            >
                {{ description }}
            </p>
            <div v-if="loading">
                <EmptySpace :options="{ size: 'xl' }" />
                <Position x="center">
                    <Loader />
                </Position>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import EmptySpace from 'widget-components/components/EmptySpace/EmptySpace.vue'
import Position from 'widget-components/components/Position/Position.vue'
import Loader from '@/components/Loader.vue'

defineProps<{
    title: string
    description?: string
    small?: boolean
    loading?: boolean
}>()
</script>
